import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "weekly",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-scheduler" */ "./components"),
        import(
          /* webpackChunkName: "unit-planner" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const importFromUnitFlowModalReducer = importedModule1.default;
        injectReducer(store, {
          key: "importFromUnitFlow",
          reducer: importFromUnitFlowModalReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentDetails(store), LeDetails(store)],
});
